import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { SUBSCRIPTION_TYPES, SUBSCRIPTION_FOOTER_TEXTS } from 'rebook/apps/payments/constants';
import PaymentsHeader from 'rebook/apps/payments/components/PaymentsHeader';
import PaymentsRibbon from 'rebook/apps/payments/components/PaymentsRibbon';
import CurrentSubscriptionLabel from 'rebook/apps/payments/components/CurrentSubscriptionLabel';
import PaymentsActionButton from 'rebook/apps/payments/components/PaymentsActionButton';

import styles from './style.scss';


const PaymentsSubscriptionHeader = (props) => {
  const { type, isGift, userEmail, payments, user, booksPerSubscriptionCounter } = props;
  const subscriptionInfo = payments.subscriptionTypes[type];
  const hasStandardSubscription = payments.subscriptionTypes.standard.userIsActive;
  const hasPremiumSubscription = payments.subscriptionTypes.pro.userIsActive;

  const isPro = type === 'pro';
  const price = get(payments, 'prices.audio["1"].advert_price_for_user', 0);
  const fullPrice = get(payments, 'prices.audio["1"].full_price', 0);
  const isSurcharge = price < fullPrice;
  const offerSurcharge = isPro && hasStandardSubscription && !hasPremiumSubscription;

  let subscriptionTypeForLabel = null;
  if (hasPremiumSubscription) {
    subscriptionTypeForLabel = payments.subscriptionTypes.pro.userActiveTill;
  }
  else if (hasStandardSubscription && !hasPremiumSubscription) {
    subscriptionTypeForLabel = payments.subscriptionTypes.standard.userActiveTill;
  }

  let subscriptionTypeTitle = `Оформление<br />${SUBSCRIPTION_TYPES[type.toUpperCase()].GEN.toLowerCase()}`;

  if (isGift) {
    subscriptionTypeTitle = `${subscriptionTypeTitle}<br />в подарок`;
  }

  const giftText = userEmail && !user.is_fake_email
    ? (
      <React.Fragment>
        <p>
          После покупки подписки вы получите код и&nbsp;подарочный сертификат, который придет
          вам на&nbsp;почту <strong>{userEmail}</strong>.
        </p>
        <p>
          Передайте код вашему другу или близкому. Он сможет активировать код на сайте или
          в&nbsp;приложении и&nbsp;читать.
        </p>
      </React.Fragment>
    )
    : (
      <p>
       После оплаты вы получите уникальный подарочный код. Передайте его другу.
       Для активации подарка нужно будет ввести код на сайте или в приложении.
      </p>
    );

  return (
    <React.Fragment>
      <div className={classNames(
        styles.wrapper,
        isPro ? 'themePro' : 'themeStandard',
        'jest-payments-subscription-header'
      )}>
        <div className={styles.container}>
          {isPro && <PaymentsRibbon size="big" />}
          <PaymentsHeader
            title={subscriptionTypeTitle}
            isGift={isGift}
            subscriptionType={type}
            booksPerSubscriptionCounter={booksPerSubscriptionCounter}
            subtitle={subscriptionInfo.description}>
            <React.Fragment>
              {isGift
                ? (
                  <div className={styles.description}>
                    {giftText}
                  </div>
                )
                : (
                  <React.Fragment>
                    <div className={classNames(styles.description, `jest-payments-subscription-header-description`)}>
                      <span dangerouslySetInnerHTML={{ __html: SUBSCRIPTION_FOOTER_TEXTS[type] }} />
                    </div>
                  </React.Fragment>
                )}
            </React.Fragment>
          </PaymentsHeader>
          {(subscriptionTypeForLabel || offerSurcharge) && (
            <div className={styles.subscriptionInfo}>
              <div className={classNames(
                styles.subscriptionInfoLabel,
                { [styles.subscriptionInfoSurcharge]: offerSurcharge },
              )}>
                {subscriptionTypeForLabel && (
                  <CurrentSubscriptionLabel
                    subsciptionActiveTill={subscriptionTypeForLabel}
                    isPro={hasPremiumSubscription} />
                )}
              </div>

              {offerSurcharge && (
                <div className={classNames('jest-payments-user-subscription-surcharge', styles.userSubscription)}>
                  <div className={styles.userSubscriptionSurcharge}>
                    <p><b>Внимание</b></p>
                    <small className={styles.surchargeDescription}>
                      Вы можете сделать доплату <br /> и пользоваться премиумом
                    </small>
                    <div className={styles.discountIcon}>%</div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {!isPro && hasStandardSubscription && !hasPremiumSubscription && (
        <div className={styles.surchargeOffer}>
          <div className={styles.surchargeOfferContainer}>
            <PaymentsActionButton
              price={price}
              fullPrice={fullPrice}
              isSurcharge={isSurcharge}
              extraClassName={styles.surchargeOfferButton}
              url={'/payments/?subscription_type=pro'}
              isPro />
            <div className={styles.surchargeOfferText}>
              Вы можете сделать доплату<br />и пользоваться премиумом
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    payments: state.payments,
    user: state.user,
    booksPerSubscriptionCounter: state.booksPerSubscriptionCounter,
  };
}

export default connect(mapStateToProps)(PaymentsSubscriptionHeader);
